<template>
    <div class="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12">
        <div class="max-w-md w-full text-center">
            <div class="mx-auto w-16 h-16 rounded-2xl bg-white border border-gray-200 shadow-sm flex items-center justify-center mb-6">
                <svg viewBox="0 0 24 24" class="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 9l1.5-5h15L21 9M3 9h18M3 9v11h18V9M9 20v-6h6v6" />
                </svg>
            </div>

            <h1 class="text-2xl font-bold text-gray-900">Loja não encontrada</h1>
            <p class="mt-2 text-gray-600">
                Não encontramos nenhuma loja neste endereço. Confira se o link está correto
                ou peça o endereço atualizado ao estabelecimento.
            </p>

            <p v-if="requestedAddress" class="mt-4 inline-block px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-sm font-mono text-gray-700 break-all">
                {{ requestedAddress }}
            </p>

            <div class="mt-10 p-6 rounded-2xl bg-white border border-gray-200 shadow-sm text-left">
                <p class="text-xs font-bold uppercase tracking-wider text-gray-400">Tem um restaurante, bar ou lanchonete?</p>
                <h2 class="mt-1 text-lg font-bold text-gray-900">Crie sua loja com cardápio digital</h2>
                <ul class="mt-3 space-y-1.5 text-sm text-gray-600">
                    <li>• Cardápio digital com a cara da sua marca</li>
                    <li>• Pedidos de delivery, retirada e mesa direto no seu painel</li>
                    <li>• Seu endereço próprio na internet em poucos minutos</li>
                </ul>
                <a
                    :href="landingUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="mt-5 w-full inline-flex items-center justify-center px-5 py-3 rounded-xl bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold transition-colors"
                >
                    Quero ter minha loja
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { landingUrl, storeSlug } from '@/global/storeAddress'

export default defineComponent({
    name: 'NonexistentDomain',
    setup() {
        const host = window.location.host
        return {
            landingUrl,
            // Without a slug there's nothing more specific than the host to show.
            requestedAddress: storeSlug ? `${host}/${storeSlug}` : '',
        }
    },
})
</script>
